import React, { useEffect } from 'react';

const STEPS = [
  {
    num: 1,
    title: 'Create your account',
    desc: 'Name, email, and a password — that\'s it.',
  },
  {
    num: 2,
    title: 'Connect your phone',
    desc: 'Verify your business number so it shows as your caller ID.',
  },
  {
    num: 3,
    title: 'Start coaching',
    desc: 'Make or receive your first AI-coached call.',
  },
];

export default function SignUpTour({ onContinue, onSignIn }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
        e.preventDefault();
        onContinue();
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [onContinue]);

  return (
    <div className="signup-tour-backdrop">
      <div className="signup-tour-card">
        <div className="signup-tour-badge">~ 30 seconds</div>
        <h2 className="signup-tour-title">Get Set Up in 30 Seconds</h2>
        <p className="signup-tour-subtitle">
          Your AI call coach is moments away. Here's what to expect.
        </p>

        <div className="signup-tour-needs">
          <div className="signup-tour-needs-label">What you'll need</div>
          <div className="signup-tour-needs-item">An email address</div>
          <div className="signup-tour-needs-item">A password (8+ characters)</div>
          <div className="signup-tour-needs-item">Your business phone number</div>
        </div>

        <div className="signup-tour-steps">
          {STEPS.map((s) => (
            <div key={s.num} className="signup-tour-step">
              <div className="signup-tour-step-dot">{s.num}</div>
              <div className="signup-tour-step-body">
                <div className="signup-tour-step-title">{s.title}</div>
                <div className="signup-tour-step-desc">{s.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <button className="signup-tour-cta" onClick={onContinue}>
          Let's Go
        </button>

        <div className="signup-tour-alt">
          Already have an account?{' '}
          <button type="button" className="signup-tour-link" onClick={onSignIn}>
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}
